// App.tsx
import React, { useEffect } from 'react';
import { Route, Routes, BrowserRouter, Navigate, useLocation } from 'react-router-dom';
import Home from './components/Home';
import TermsPage from './components/Terms';
import PrivacyPage from './components/Privacy';
import { trackPageView } from './analytics';
import FounderLogin from './components/founderDashboard/FounderLogin';
import ProtectedRoute from './components/founderDashboard/ProtectedRoute';
import SharedWorkout from './components/SharedWorkout';
import GrowthDashboard from './components/founderDashboard/GrowthDashboard';
import UsageDashboard from './components/founderDashboard/UsageDashboard';
import InsightsDashboard from './components/founderDashboard/InsightsDashboard';
import TodayDashboard from './components/founderDashboard/TodayDashboard';
import PipelineDashboard from './components/founderDashboard/PipelineDashboard';

// This component listens for route changes and notifies GA
function GAListener() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    trackPageView(path);
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  return (
    <main className='site-wrapper'>
      <BrowserRouter>
        {/* GA listener lives inside BrowserRouter, outside Routes */}
        <GAListener />

        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/terms' element={<TermsPage />} />
          <Route path='/privacy' element={<PrivacyPage />} />
          <Route path='/founder/login' element={<FounderLogin />} />
          <Route path='/founder' element={<Navigate to='/founder/today' replace />} />
          <Route path='/share/wo/:token' element={<SharedWorkout />} />
          <Route
            path='/founder/today'
            element={
              <ProtectedRoute>
                <TodayDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path='/founder/growth'
            element={
              <ProtectedRoute>
                <GrowthDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path='/founder/insights'
            element={
              <ProtectedRoute>
                <InsightsDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path='/founder/usage'
            element={
              <ProtectedRoute>
                <UsageDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path='/founder/pipeline'
            element={
              <ProtectedRoute>
                <PipelineDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </main>
  );
}

export default App;
